import { render, staticRenderFns } from "./SearchIcon.vue?vue&type=template&id=3cacdc9e&scoped=true"
import script from "./SearchIcon.vue?vue&type=script&lang=js"
export * from "./SearchIcon.vue?vue&type=script&lang=js"
import style0 from "./SearchIcon.vue?vue&type=style&index=0&id=3cacdc9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cacdc9e",
  null
  
)

export default component.exports